import {BaseSpringServiceCB} from "@aiknow-srl/aik-ngx-http";
import {MetricOPEEnum} from "./MetricOPEEnum";

/**
 * O Inner Class
 */
class O {
}

class I {
  metricInstanceId!: number;
  valueToWrite!: number | string | boolean;
}


export class ExecWM2ECB extends BaseSpringServiceCB {
  /**
   * Input
   */
  public i: I;
  /**
   * Output
   */
  public o: O;

  /**
   * Class constructor
   */
  constructor() {
    super(MetricOPEEnum.ExecWM2E);
    this.i = new I();
    this.o = new O();
  }
}
